import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Modal } from 'react-bootstrap';
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';

export function AlertDialog({ title, type = 'info', msg, confirmLabel = 'OK', onClose, onConfirm }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const warning = ['warning', 'question', 'confirm'].includes(type);
  const danger = ['error', 'danger'].includes(type);
  const Icon = warning || danger ? FaExclamationTriangle : type === 'success' ? FaCheckCircle : FaInfoCircle;
  const close = () => { if (!busy) onClose(false); };
  const confirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (onConfirm) await onConfirm();
      onClose(true);
    } catch (failure) {
      setError(failure.message || 'Proses gagal. Silakan coba lagi.');
      setBusy(false);
    }
  };
  return (
    <Modal show centered onHide={close} keyboard={!busy} backdrop={busy ? 'static' : true} dialogClassName="sap-alert-dialog" aria-labelledby="sap-alert-title">
      <Modal.Header>
        <Modal.Title id="sap-alert-title"><Icon /> {title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={`sap-alert-message sap-alert-${danger ? 'danger' : warning ? 'warning' : type}`}>
          <div className="sap-alert-symbol"><Icon /></div>
          <div><strong>{msg}</strong><p>Pilih tindakan untuk melanjutkan proses.</p></div>
        </div>
        {error && <p className="sap-alert-error" role="alert">{error}</p>}
      </Modal.Body>
      <Modal.Footer>
        {onConfirm && <button className="sap-alert-button" disabled={busy} onClick={close} autoFocus>Nanti Saja</button>}
        <button className={`sap-alert-button ${onConfirm ? 'sap-alert-confirm' : ''}`} disabled={busy} onClick={confirm} autoFocus={!onConfirm}>{busy ? 'Memproses...' : confirmLabel}</button>
      </Modal.Footer>
      <div className="sap-alert-status"><span>{warning ? 'Peringatan' : danger ? 'Kesalahan' : 'Informasi'}</span><span>ESC: kembali</span></div>
    </Modal>
  );
}

export function openAlert(options) {
  return new Promise(resolve => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);
    const close = result => {
      root.unmount();
      container.remove();
      resolve(result);
    };
    root.render(<AlertDialog {...options} onClose={close} />);
  });
}
